import { CustomerGroupResponse } from '@/modules/configurationModule/detail/accounting/billable/customer-groups/services/customer-groups.dto'
import { CustomerTypeResponse } from '@/modules/configurationModule/detail/accounting/billable/customer-types/services/customer-types.dto'
import { StrictNullable } from '@/shared/types/app.types'
import { store } from '@/store/store'

export interface ConfigurationLocalAccountingCustomersModalBasicFormValues {
    id?: number
    name: string
    code: string
    taxIdentificationNumber: string
    active: boolean
    priorityForAutomaticAssignment: number
    customerGroup: StrictNullable<CustomerGroupResponse>
    customerType: StrictNullable<CustomerTypeResponse>
}

export interface ConfigurationLocalAccountingCustomersModalBasicFormState {
    customer: ConfigurationLocalAccountingCustomersModalBasicFormValues
    laboratoryId: number
}

export interface ConfigurationLocalAccountingCustomersModalBasicFormValidation {
    required: boolean
    regex: RegExp
}
export const initialLocalAccountingCustomersModalBasicFormState =
    (): ConfigurationLocalAccountingCustomersModalBasicFormState => ({
        customer: {
            name: '',
            code: '',
            taxIdentificationNumber: '',
            active: true,
            priorityForAutomaticAssignment: 1,
            customerGroup: null,
            customerType: null
        },
        laboratoryId: store.getters.labId
    })
